import React from 'react';
import PropTypes from 'prop-types';
import { Box, Spinner } from 'wt-ui';
import Message from '../../components/Message';

// import mock from './mockData';

const MsgHistory = (props) => {
  const { data, loading } = props;
  // console.log('MsgHistory', JSON.stringify(data));
  return (
    <Box background="transparent" pad={{ top: 'medium' }}>
      <Box background="transparent" align="start" gap="medium">
        {data.map((x) => (
          <Message key={x.dtKey} data={x} />
        ))}
      </Box>
      <Box background="transparent" align="center">
        {loading === true ? <Spinner primary /> : ''}
      </Box>
    </Box>
  );
};

MsgHistory.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default MsgHistory;
